import { render } from "./History.vue?vue&type=template&id=2b9f695d"
import script from "./History.vue?vue&type=script&lang=js"
export * from "./History.vue?vue&type=script&lang=js"
script.render = render

export default script